import { Box, HStack, Header, Text } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { MENU_TILE_GRID_HALF_GAP } from 'pages/menu/components/menu-tile-grid/styled';
import { theme } from 'styles/configure-theme';
import { primitive } from 'styles/constants/primitives';

const MENU_TILE_MIN_WIDTH = '132px';

export const MenuSectionContainer = Box.withConfig({
  flex: 1,
  justifyContent: 'space-between',
});

export const MenuSectionRow = HStack.withConfig(() => ({
  flexShrink: 1,
  flexGrow: 1,
  backgroundColor: primitive.$white,
  height: '112px',
  alignItems: 'center',
  paddingX: '$4',
  paddingY: '$2',
  _web: {
    cursor: 'pointer',
  },
  minHeight: {
    md: '320px',
  },
}));

export const MenuSectionImageWrapper = Box.withConfig({
  minWidth: MENU_TILE_MIN_WIDTH,
});

export const MenuSectionImage = Picture.withConfig(() => ({
  width: {
    base: MENU_TILE_MIN_WIDTH,
    md: 'full',
  },
  height: { base: '90px', md: '160px' },
  borderTopRadius: Styles.borderRadius,
  borderBottomRadius: {
    base: Styles.borderRadius,
    md: 0,
  },
}));

export const MenuSectionContent = Box.withConfig({
  flexShrink: 1,
  paddingX: {
    base: '$3',
    md: '$8',
  },
  paddingY: {
    base: 0,
    md: '$5',
  },
});

export const MenuSectionTitle = Header.withConfig(() => ({
  variant: 'headerTwo',
  fontSize: {
    base: 'lg',
    md: '2xl',
  },
  margin: 0,
  textTransform: 'none',
  numberOfLines: 2, // causes ellipsis
  _web: {
    lineHeight: 'normal',
  },
}));

export const MenuSectionProductWrapper = HStack.withConfig({
  alignItems: 'center',
  justifyContent: 'flex-start',
  space: '$2',
});

export const MenuSectionItemPrice = Text.withConfig({
  fontWeight: 'bold',
  color: Styles.color.pricing,
  marginTop: '1',
  marginRight: {
    base: '1',
    md: '0',
  },
});

export const MenuSectionItemCalories = Text.withConfig({
  numberOfLines: 1,
  color: Styles.color.tertiary,
  marginTop: '1',
  marginBottom: '0',
  textTransform: 'capitalize',
});

// Grid Styles

export const MenuSectionGridItemWrapper = Box.withConfig({
  margin: `${MENU_TILE_GRID_HALF_GAP}px`,
  _web: {
    maxWidth: `calc(33% - ${MENU_TILE_GRID_HALF_GAP}px)`,
  },
  borderRadius: 12,
  minHeight: '220px',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
});

export const MenuSectionGridFooter = Box.withConfig<{ isMenuItem: boolean }>(p => ({
  justifyContent: 'center',
  alignItems: 'center',
  height: p.isMenuItem ? '92px' : '54px',
  borderBottomRadius: Styles.borderRadius,
  _text: {
    variant: 'headerTwo',
    color: theme.token('text-default'),
    margin: '0',
    fontSize: 'lg',
    lineHeight: '20px',
    textAlign: 'center',
  },
}));
